<template>
  <aside class="sidebar" :class="customClasses">
    <TheSidebarHeader :title="$t('message.common.sidebar.title')" />
    <HubSidebar name="stewardship" :content="stewardship" v-if="!stewardship.hidden" />
    <HubSidebar name="documents" :content="documents" v-if="!documents.hidden" />
    <HubSidebar name="events" :content="events" v-if="!events.hidden" />
    <HubSidebar name="workgroups" :content="workgroups" v-if="!workgroups.hidden" />
    <HubSidebar name="holidays" :content="holidays" v-if="!holidays.hidden"/>
    <HubSidebar name="travels" :content="travels" v-if="!travels.hidden" />
    <HubSidebar name="remoteWorking" :content="remoteWorking" v-if="!remoteWorking.hidden" />
  </aside>
</template>

<script>
import { mapGetters } from 'vuex'
import TheSidebarHeader from './TheSidebarHeader'
import HubSidebar from '@blocks/hubs/HubSidebar'
export default {
  name: 'Sidebar',
  components: {
    TheSidebarHeader,
    HubSidebar
  },
  computed: {
    ...mapGetters({
      isVisible: 'myspace/getIsVisible',
      stewardship: 'myspace/getStewardship',
      documents: 'myspace/getDocuments',
      events: 'myspace/getEvents',
      workgroups: 'myspace/getWorkgroups',
      holidays: 'myspace/getHolidays',
      travels: 'myspace/getTravels',
      remoteWorking: 'myspace/getRemoteWorking'
    }),
    customClasses () {
      return [
        { 'is-visible': this.isVisible }
      ]
    }
  },
  methods: {
  }
}
</script>

<style lang="scss">
  .sidebar{
    @media print {
      display: none !important;
    }
    @include add-transition;
    width: 0rem;
    background-color: colors("foreground");

    &.is-visible{
      width: 30rem;
    }

    .hub-sidebar{
      @include media("small-medium"){

      }
      @include media("large"){
        width: 30rem;
      }
    }
    .button{
      padding: 0.5em 1em;
    }
  }
</style>
